import { StatsDataAgentInterface } from 'pf-frontend-common/src/module/stats/data/agent.interface';

import { AgentModel } from 'common/data/agent/model';

export class AgentStatsDataAdapter {
  /**
   * Return an agent model as agent stats data
   *
   * @param position - SERP position
   */
  public getData(agentModel: AgentModel, position?: number, positionPage?: number): StatsDataAgentInterface {
    return {
      id: parseInt(agentModel.id, 10),
      name: agentModel.name,
      broker: {
        id: parseInt(agentModel.meta.broker_id, 10),
        name: agentModel.meta.broker_name,
      },
      jobPosition: agentModel.position,
      rera: agentModel.agent_broker_license_no,
      image: agentModel.links.image_desktop,
      listingStatus: 'Area Specialist Agent', // agent doesn't support yet listingStatus like PropertyModel
      position: position || 0,
      positionPage: positionPage || position || 0,
      isSmartAd: agentModel.smart_ad ? 1 : 0,
      isSmartAdAgent: agentModel.smart_ad ? 1 : 0,
      isVerified: agentModel.isVerified(),
    };
  }
}
